<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Establecimiento {{ form.numero_localidad }}</h3>
      </div>
      <div class="layout__controls">
        <button v-show="(permiteEditarLocalidad || permiteEliminarLocalidad)" @click="$modal.show('listaLocalidades')"
          class="btn-info btn--bigger" type="submit"><i class="fa fa-search"></i> <span>Buscar</span></button>
        <modal :width="'60%'" height="auto" :scrollable="true" name="listaLocalidades">
          <lista-localidades :createButton="false" @selected="selectedLocalidad"></lista-localidades>
        </modal>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información del establecimiento</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <input-field v-model="form.numero_localidad" type="tel" v-mask="'###'" id="numero_localidad"
                    placeholder="N° de localidad">
                    Número de establecimiento *
                    <span v-if="errores.numero_localidad" class="helper-text text-danger" slot="helper">
                      {{ errores.numero_localidad[0] }}
                    </span>
                  </input-field>
                </div>
                <div class="form-field">
                  <input-field v-model="form.descripcion" id="descripcion" placeholder="Descripción de la localidad">
                    Descripción *
                    <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                      {{ errores.descripcion[0] }}
                    </span>
                  </input-field>
                </div>
                <div v-if="id != ''" class="form-field">
                  <form method="POST" enctype="multipart/form-data" :action="url + '/subir-foto-localidad/' + id">
                    <input type="hidden" name="_token" id="csrf-token" :value="token" />
                    <label for="url_logo"><strong>Logo de Establecimiento</strong></label>
                    <input @change="changeUrlLogo" type="file" name="url_logo" id="url_logo">
                    <button type="submit" class="btn-success"><i class="fa fa-upload"></i></button>
                  </form>
                  <br>
                  <img :src="urlLogoEstablecimiento" alt="Logo de Establecimiento" width="100px">
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <input-field v-model="form.nombre_comercial" id="nombre_comercial" placeholder="Nombre comercial">
                    Nombre comercial
                    <span v-if="errores.nombre_comercial" class="helper-text text-danger" slot="helper">
                      {{ errores.nombre_comercial[0] }}
                    </span>
                  </input-field>
                </div>
                <div class="form-field">
                  <input-field v-model="form.direccion" id="direccion" placeholder="Dirección de la localidad">
                    Dirección *
                    <span v-if="errores.direccion" class="helper-text text-danger" slot="helper">
                      {{ errores.direccion[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12">
                <tabla-punto-emision :errores="errores" v-model="form.puntosEmision"></tabla-punto-emision>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button v-show="(permiteCrearLocalidad && estado === 'N') || (permiteEditarLocalidad && estado !== 'N')"
              @click="guardarLocalidad" type="button" class="btn-success"><i class="fa fa-save"></i> <span>Guardar</span></button>
            <button v-show="permiteCrearLocalidad" @click="crearLocalidad" type="button" class="btn-light btn--text"><i
                class="fa fa-plus"></i> <span>Nuevo</span></button>
            <button v-show="permiteEliminarLocalidad && estado === 'A'" @click="eliminarLocalidad" type="button" class="btn-danger btn--text"><i
                class="fa fa-ban"></i> <span>Eliminar</span></button>
            <button v-show="permiteEliminarLocalidad && estado === 'I'" @click="eliminarLocalidad" type="button" class="btn-success btn--text"><i
                class="fa fa-power-off"></i> <span>Re-activar</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props : {
      token: {
          type: String,
          required: false,
          default: ''
        },
        permiteCrearLocalidad : {
            type : Boolean,
            default : true,
            required : true
        },
        permiteEditarLocalidad : {
            type : Boolean,
            default : true,
            required : true
        },
        permiteEliminarLocalidad : {
            type : Boolean,
            default : true,
            required : true
        },
        localidad: {
          type: Object,
          required: false,
          default: function () {
            return null;
          }
        }
    },
    data : function () {
        return {
          urlLogoEstablecimiento: url + '/images/no-logo.png',
            form : {
                puntosEmision : [],
                numero_localidad : '',
                descripcion : '',
                direccion : '',
                _method : undefined,
                nombre_comercial: ''
            },
            url : url,
            estado : 'N',
            errores : {
                puntosEmision : undefined,
                numero_localidad : undefined,
                descripcion : undefined,
                direccion : undefined,
                nombre_comercial: undefined
            },
            id : ''
        };
    },
    methods : {
        changeUrlLogo: function(e) {
          let file = e.target.files[0];
          this.urlLogoEstablecimiento = URL.createObjectURL(file);
        },
        guardarLocalidad : function () {
            let that = this;
            let urlRequest = this.url + '/localidades';
            this.errores = {
                puntosEmision : undefined,
                numero_localidad : undefined,
                descripcion : undefined,
                direccion : undefined,
                nombre_comercial: undefined
            };
            if (that.estado !== 'N')
            {
                urlRequest += '/' + this.id;
                this.form._method = 'PUT';
            }
            else 
                this.form._method = undefined;
            axios.post(urlRequest, this.form).then(function (response) {
                swal('El establecimiento ha sido almacenado con éxito.', 'Realizado', 'success');
                that.id = response.data.id;
                that.estado = response.data.estado;
            }).catch(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== undefined && response !== null) {
                        if (response.status === 422)
                        {
                            that.errores = response.data.errors;
                            swal('El formulario posee errores.', 'Aviso', 'warning');
                        }
                        else 
                            swal('Hubo un error al momento de almacenar la información, intente nuevamente.', 'Error', 'error');
                    }
                }
            });
        },
        eliminarLocalidad : function () {
            let that = this;
            swal({
                    title: '¿Está seguro de ' + (this.estado === 'A'?'eliminar':'re-activar') + ' este establecimiento?',
                    text: "El establecimiento será eliminado.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText : this.estado === 'A'?'Eliminar':'Re-activar',
                    cancelButtonText : 'Cancelar'
                    }).then((result) => {
                        if (result.value)
                            axios.post(that.url + '/localidades/' + that.id, {
                                _method : 'DELETE'
                            }).then(function (response) {
                                that.estado = response.data.estado;
                                swal('El establecimiento ha sido ' + (that.estado === 'A'?'eliminado':'re-activado') + ' con éxito.',
                                    'Realizado', 'success');
                            });
                });
        },
        selectedLocalidad : function (localidad) {
            this.limpiarFormulario();
            this.id = localidad.id;
            this.form.numero_localidad = localidad.numero_localidad;
            this.form.direccion = localidad.direccion;
            this.form.descripcion = localidad.descripcion;
            this.form.nombre_comercial = localidad.nombre_comercial;
            this.estado = localidad.estado;
            this.urlLogoEstablecimiento = localidad.link_url_logo;
            for (let i = 0; i < localidad.puntos_emision.length; i++)
            {
                let puntoEmision = {
                    id : localidad.puntos_emision[i].id,
                    numero_secuencia : localidad.puntos_emision[i].numero_secuencia,
                    descripcion : localidad.puntos_emision[i].descripcion,
                    id_tipo_comprobante : localidad.puntos_emision[i].id_tipo_comprobante,
                    tipo : localidad.puntos_emision[i].tipo,
                    numero_actual : localidad.puntos_emision[i].numero_actual,
                    numero_inicial : localidad.puntos_emision[i].numero_inicial,
                    numero_final : localidad.puntos_emision[i].numero_final,
                    numero_autorizacion : localidad.puntos_emision[i].numero_autorizacion,
                    fecha_autorizacion : localidad.puntos_emision[i].fecha_autorizacion !== null?moment(new Date(localidad.puntos_emision[i].fecha_autorizacion)).format('YYYY-MM-DD'):moment(new Date()).format('YYYY-MM-DD'),
                    estado : localidad.puntos_emision[i].estado,
                    fecha_caducidad : localidad.puntos_emision[i].fecha_caducidad !== null?moment(new Date(localidad.puntos_emision[i].fecha_caducidad)).format('YYYY-MM-DD'):moment(new Date()).format('YYYY-MM-DD'),
                    medida_superior : localidad.puntos_emision[i].medida_superior,
                    medida_inferior : localidad.puntos_emision[i].medida_inferior,
                    punto_venta : localidad.puntos_emision[i].punto_venta === 'S',
                    pre_impresion : localidad.puntos_emision[i].pre_impresion === 'S',
                    usuarios : [],
                    es_autorizable: localidad.puntos_emision[i].es_autorizable === 'S',
                    precargar_numero: localidad.puntos_emision[i].precargar_numero === 'S',
                    nombre_campo: localidad.puntos_emision[i].nombre_campo,
                    valor_campo: localidad.puntos_emision[i].valor_campo,
                    app: localidad.puntos_emision[i].app === 'S',
                    autorizar_automatico: localidad.puntos_emision[i].autorizar_automatico === 'S',
                    usuario_id: localidad.puntos_emision[i].usuario_id
                };
                for (let j = 0; j < localidad.puntos_emision[i].usuarios.length; j++)
                    puntoEmision.usuarios.push(localidad.puntos_emision[i].usuarios[j].id);
                this.form.puntosEmision.push(puntoEmision);
            }
            this.$modal.hide('listaLocalidades');
        },
        crearLocalidad : function () {
            let that = this;
            swal({
                title: '¿Desea crear un nuevo establecimiento?',
                text: "El formulario será reiniciado.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : 'Crear nueva',
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        that.estado = 'N';
                        that.limpiarFormulario();
                    }
            });
        },
        limpiarFormulario : function () {
            this.form = {
                puntosEmision : [],
                numero_localidad : '',
                descripcion : '',
                direccion : '',
                _method : undefined,
                nombre_comercial: ''
            };
            this.errores = {
                puntosEmision : undefined,
                numero_localidad : undefined,
                descripcion : undefined,
                direccion : undefined,
                nombre_comercial: undefined
            };
            this.id = '';
        }
    },
    mounted: function () {
      if (this.localidad != null) {
        this.selectedLocalidad(this.localidad);
      }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/localidades/Localidad.vue